'use strict';

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _debug = require('debug');

var _debug2 = _interopRequireDefault(_debug);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var log = (0, _debug2.default)('linksoft:datatables:excelExport');

var excelHtml5 = _jquery2.default.fn.DataTable.ext.buttons.excelHtml5;
var internal = _jquery2.default.fn.DataTable.ext.internal;
var pageSize = 100; // todo: change page size by config value
var DataTable = _jquery2.default.fn.DataTable;
var Api = DataTable.Api;

DataTable.ext.buttons.excelExport = {
	name: 'excelExport',
	extend: 'excelHtml5',
	className: 'excel-export',
	text: function text(dt) {
		return dt.i18n('buttons.exportExcel', '<i class="fa fa-download" /><i class="fa fa-refresh fa-spin" /><span class="progress"><span class="progress-bar"></span></span>&nbsp;Excel');
	},
	exportOptions: {
		columns: ':visible',
		data: []
	},
	action: function action(e, dt, button, config) {
		log('Excel Export button clicked');
		if ((0, _jquery2.default)(button).is('.in-progress')) {
			return; // TODO: cancel support could be implemented here
		}
		(0, _jquery2.default)(button).find('.progress-bar').css({ width: 0 });
		(0, _jquery2.default)(button).addClass('in-progress btn-orange');
		loadData(dt, config, function (e) {
			log('export progress: %d', e.percentage);
			(0, _jquery2.default)(button).find('.progress-bar').css({ width: e.percentage + '%' });
		}).then(function (data) {
			config.exportOptions.data = data;
			excelHtml5.action(e, dt, button, config);
			config.exportOptions.data = [];

			(0, _jquery2.default)(button).removeClass('in-progress btn-orange');
		}, function () {
			(0, _jquery2.default)(button).removeClass('in-progress btn-orange');
		});
	}
};

function loadData(dt, config, progress) {
	log('Excel Export - preparing context...');
	if (dt.context.length) {
		var calcProgress = function calcProgress(context) {
			log('export progress details: %d + %d / 2x %d', context.loadedCount, context.outputCount, context.total);
			progress({ percentage: Math.round((context.loadedCount + context.outputCount * 2) / (context.total * 3) * 100) });
		};

		var settings = dt.context[0];
		var args = internal._fnAjaxParameters(settings);

		// set page size
		args.length = pageSize;
		// set array of column indexes to export
		config.exportOptions = {
			columns: dt.columns(':visible').map().filter(function (c) {
				return !c.options().excludeFromExport;
			}).map(function (c) {
				return c.index();
			}),
			data: []
		};

		var context = {
			dt: dt,
			settings: settings,
			config: config,

			loadArgs: args,
			loadComplete: false,
			rawData: [],
			loadedCount: 0,
			total: 0,

			processingComplete: false,
			outputData: [],
			outputCount: 0
		};

		log('Export to excel has started...');
		return Promise.all([loadNextPage(context, calcProgress), processData(context, calcProgress)]).then(function (results) {
			log('export complete %o', results);
			return context.outputData;
		});
	}
}

function loadNextPage(context, progress) {
	return wait(0).then(function () {
		if (context.loadComplete) {
			log('loading page data end');
			return context;
		}
		log('loading page data start');
		var start = context.loadedCount;
		var settings = context.settings;
		var args = context.loadArgs;

		args.start = start;
		return performAjax(settings, args).then(function (json) {
			context.total = json['@odata.count'];
			context.loadedCount = start + json.value.length;
			json.value.forEach(function (row) {
				return context.rawData.push(row);
			});
			context.loadComplete = context.total <= context.loadedCount;
			progress(context);
		}).then(function () {
			return loadNextPage(context, progress);
		});
	});
}

function processData(context, progress) {
	return wait(0).then(function () {
		if (context.processingComplete) return context;
		if (context.rawData.length > 0) {
			processRow(context, context.rawData.shift());
			progress(context);
			if (context.rawData.length > 0) {
				return processData(context, progress); // continue
			} else {
				// processing complete
				context.processingComplete = true;
				return context;
			}
		} else if (!context.loadComplete) {
			// wait a moment and try i again - page is still loading
			return wait(150).then(function () {
				return processData(context, progress);
			});
		} else {
			// processing complete
			context.processingComplete = true;
			return context;
		}
	});
}

function wait(delay) {
	return new Promise(function (resolve) {
		return setTimeout(resolve, delay);
	});
}

function processRow(context, row) {
	var indexes = context.dt.columns(context.config.exportOptions.columns).indexes();
	log('processing row: %d, %o', context.outputCount, indexes);
	var cells = indexes.map(function (idx) {
		var col = context.dt.column(idx);
		var value = row[col.dataSrc()];
		var displayValue = col.renderer().exportRender(value, row, {
			col: idx,
			row: context.outputData.length + 1,
			settings: context.settings
		});
		return strip()(displayValue);
	}).toArray();

	log('processing row %d complete', context.outputCount);
	context.outputData.push(cells);
	context.outputCount++;
}

function performAjax(settings, args) {
	return new Promise(function (resolve) {
		internal._fnBuildAjax(settings, args, function (json) {
			resolve(json);
		});
	});
}

Api.register('buttons.exportData()', function (options) {
	if (this.context.length) {
		return _exportData(new Api(this.context[0]), options);
	}
});

var _exportTextarea = (0, _jquery2.default)('<textarea/>')[0];
var _exportData = function _exportData(dt, inOpts) {
	var config = _jquery2.default.extend(true, {}, {
		rows: null,
		columns: '',
		modifier: {
			search: 'applied',
			order: 'applied'
		},
		orthogonal: 'display',
		stripHtml: true,
		stripNewlines: true,
		decodeEntities: true,
		trim: true

	}, inOpts);

	config.format = {
		header: strip(config),
		footer: strip(config),
		body: strip(config)
	};

	var header = dt.columns(config.columns).indexes().map(function (idx) {
		var el = dt.column(idx).header();
		return config.format.header(el.innerHTML, idx, el);
	}).toArray();

	var footer = dt.table().footer() ? dt.columns(config.columns).indexes().map(function (idx) {
		var el = dt.column(idx).footer();
		return config.format.footer(el ? el.innerHTML : '', idx, el);
	}).toArray() : null;

	return {
		header: header,
		footer: footer,
		body: config.data
	};
};

var strip = function strip() {
	var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { stripHtml: true, trim: true, decodeEntities: true };

	return function (str) {
		if (typeof str !== 'string') {
			return str;
		}

		if (config.stripHtml) {
			str = str.replace(/<[^>]*>/g, '');
		}

		if (config.trim) {
			str = str.replace(/^\s+|\s+$/g, '');
		}

		if (config.stripNewlines) {
			str = str.replace(/\n/g, ' ');
		}

		if (config.decodeEntities) {
			_exportTextarea.innerHTML = str;
			str = _exportTextarea.value;
		}
		return str;
	};
};


//////////////////
// WEBPACK FOOTER
// ./~/linksoft/data-tables/buttons/excelExport.js
// module id = 1111
// module chunks = 1